import { storeProceduresService } from "../_services/stored.procedures.service";

export const storeProceduresAction = {
  get_crime_data_shirshak,
  get_crime_data_laghu_shirshak,
  get_crime_data_modas,
  get_crime_data_kayda,
  get_crime_data_shirshak_haddit_gunhe,
  get_crime_data_laghu_shirshak_haddit_gunhe,
  get_crime_data_modas_haddit_gunhe,
  get_crime_data_kayda_haddit_gunhe,
  get_crime_data_shirshak_usr,
  get_crime_data_laghu_shirshak_usr,
  get_crime_data_kayda_usr,
  get_crime_data_modas_usr,
};
function get_crime_data_shirshak(values) {
  return storeProceduresService.get_crime_data_shirshak(values);
}
function get_crime_data_laghu_shirshak(values) {
  return storeProceduresService.get_crime_data_laghu_shirshak(values);
}
function get_crime_data_modas(values) {
  return storeProceduresService.get_crime_data_modas(values);
}
function get_crime_data_kayda(values) {
  return storeProceduresService.get_crime_data_kayda(values);
}
function get_crime_data_shirshak_haddit_gunhe(values) {
  return storeProceduresService.get_crime_data_shirshak_haddit_gunhe(values);
}
function get_crime_data_laghu_shirshak_haddit_gunhe(values) {
  return storeProceduresService.get_crime_data_laghu_shirshak_haddit_gunhe(
    values
  );
}
function get_crime_data_modas_haddit_gunhe(values) {
  return storeProceduresService.get_crime_data_modas_haddit_gunhe(values);
}
function get_crime_data_kayda_haddit_gunhe(values) {
  return storeProceduresService.get_crime_data_kayda_haddit_gunhe(values);
}
function get_crime_data_shirshak_usr(values) {
  return storeProceduresService.get_crime_data_shirshak_usr(values);
}
function get_crime_data_laghu_shirshak_usr(values) {
  return storeProceduresService.get_crime_data_laghu_shirshak_usr(values);
}
function get_crime_data_kayda_usr(values) {
  return storeProceduresService.get_crime_data_kayda_usr(values);
}
function get_crime_data_modas_usr(values) {
  return storeProceduresService.get_crime_data_modas_usr(values);
}
